<template>
            <el-menu
          :router="true"
          :style="$mq !== 'xs' ? {'max-width': 12 + 'em'} : {'border': 0 + 'px'}"
          text-color="#a9a9a9"
          :class="$mq === 'xs' ? 'small' : ''"
          class="nxs-el-menu-vertical"
          :collapse="collapsed"
          :collapse-transition="false"
          @select="closeModal"
          :default-active="this.$router.currentRoute.path"
        >
          <span v-show="!admin">
            <el-menu-item index="/home">
              <i class="material-icons-outlined md-18">home</i>
              <span slot="title">Home</span>
            </el-menu-item>
            <el-menu-item index="/home/users">
              <i class="material-icons-outlined md-18">people</i>
              <span slot="title">Users</span>
            </el-menu-item>
            <el-menu-item index="/home/attendance">
              <i class="material-icons-outlined md-18">event</i>
              <span slot="title">Attendance</span>
            </el-menu-item>
            <el-menu-item
              v-if="$store.state.user.primary_position != null"
              index="/home/objectives"
            >
              <i class="material-icons-outlined md-18">poll</i>
              <span slot="title">Objectives</span>
            </el-menu-item>
            <el-menu-item index="/home/updates">
              <i class="material-icons-outlined md-18">inbox</i>
              <span slot="title">Updates</span>
            </el-menu-item>
            <hr style="margin: 8px;" />
            <el-menu-item index="LRSForm" @click="navigateExternal('https://form.jotform.com/233093887004155')">
              <i class="material-icons-outlined md-18">business_center</i>
              <span slot="title">LRS Form</span>
            </el-menu-item>
            <el-menu-item index="Slack" @click="navigateExternal('https://det538.slack.com/')">
              <i class="fab fa-slack" />
              <span slot="title">Slack</span>
            </el-menu-item>
          </span>
          <span v-show="admin">
            <el-menu-item index="/admin">
              <i class="material-icons-outlined md-18">home</i>
              <span slot="title">Dashboard</span>
            </el-menu-item>
            <el-menu-item
              v-if="$store.getters.hasPermission(['Auditing-All', 'Auditing-Index'])"
              index="/admin/audits"
            >
              <i class="material-icons-outlined md-18">list_alt</i>
              <span slot="title">Audits</span>
            </el-menu-item>
            <el-menu-item
              v-if="$store.getters.hasPermission(['Disputes', 'Dispute-Finalize', 'Dispute-Approve'])"
              index="/admin/disputes"
            >
              <i class="material-icons-outlined md-18">outlined_flag</i>
              <span slot="title">Disputes</span>
            </el-menu-item>
            <el-menu-item
              v-if="$store.getters.hasPermission(['Records', 'EventScanning'])"
              index="/admin/eventsbytype"
            >
              <i class="material-icons-outlined md-18">event</i>
              <span slot="title">Events</span>
            </el-menu-item>
            <el-menu-item
              v-if="$store.getters.hasPermission(['Records', 'Web'])"
              index="/admin/objectives"
            >
              <i class="material-icons-outlined md-18">poll</i>
              <span slot="title">Objectives</span>
            </el-menu-item>
            <el-menu-item
              v-if="$store.getters.hasPermission(['Updates', 'Updates-Publish'])"
              index="/admin/updates"
            >
              <i class="material-icons-outlined md-18">inbox</i>
              <span slot="title">Updates</span>
            </el-menu-item>
            <el-menu-item
              v-if="$store.getters.hasPermission(['Web', 'Records'])"
              index="/admin/organization"
            >
              <i class="material-icons-outlined md-18">business</i>
              <span slot="title">Organization</span>
            </el-menu-item>
            <el-menu-item
              v-if="$store.getters.hasPermission(['Web'])"
              index="/admin/settings"
            >
              <i class="material-icons-outlined md-18">settings</i>
              <span slot="title">Settings</span>
            </el-menu-item>
            <span v-if="$store.getters.hasPermission(['Develop'])">
              <hr style="margin: 8px;" />
              <el-menu-item
                index="Horizon"
                @click="navigateExternal('https://afsabre.rit.edu/horizon')"
              >
                <i class="fas fa-cogs"></i>
                <span slot="title">Horizon</span>
              </el-menu-item>
            </span>
            <el-menu-item
              index="/admin/about">
              <i class="material-icons-outlined md-18">info</i>
              <span slot="title">About</span>
            </el-menu-item>
          </span>
          <hr style="margin: 8px;" />
          <el-menu-item
            href="/logout"
            onclick="event.preventDefault(); document.getElementById('logout-form').submit();"
            index="Logout"
          >
            <form id="logout-form" action="/logout" method="POST" style="display: none;">
              <input type="hidden" name="_token" :value="$store.state.csrfToken" />
            </form>
            <i class="material-icons-outlined md-18">exit_to_app</i>
            <span slot="title">Logout</span>
          </el-menu-item>
          <el-collapse-transition>
            <div
              v-if="admin"
             v-show="!collapsed">
              <hr style="margin: 8px;" />
              <el-select
                v-model="selectedTerms"
                class="no-border"
                size="small"
                style="display: inline-block; margin: 8px 8px 16px 8px;"
                collapse-tags
                multiple
                placeholder="Select Term"
              >
                <el-option
                  v-for="item in terms"
                  :key="item.term"
                  :label="item.name"
                  :value="item.term"
                />
              </el-select>
            </div>
          </el-collapse-transition>
        </el-menu>
</template>

<style>
.nxs-el-menu-vertical.small, .menuitem {
  text-align: center;
}
</style>

<script>
import {mapFields} from "vuex-map-fields";
export default {
    mounted () {
        if (this.terms == null) this.$store.dispatch("pullTerms");
    },
    props: {
        collapsed: {default: false},
        admin: {required: true}
    },
    computed: {
        ...mapFields(["terms", "selectedTerms"]),
        canInventory() {
            if (this.$store.getters.hasPermission(["All", "Inventory"])) return true;
            return this.canapprove;
        }
    },
    methods: {
        closeModal() {
            this.$emit('closeModal');
        },
        navigateExternal(url) {
            window.location = url;
        }
    }
}
</script>
